import React from 'react';

import querystringify from 'querystringify';
import { isNil, has, find, isEmpty, startsWith } from 'lodash';

import { GET_USERS_IDP_URL } from '../../../constants/api';
import { isValidEmail } from '../../../lib/ValidationUtils';

import {
  GOOGLE_SSO_ENABLED,
  BASIC_LOGIN_ENABLED,
  AUTO_LOGIN_ENABLED,
} from '../../../constants/config';

import { SSO_AUTH_TYPES } from '../../../constants/auth';
import { generateTokenIdentifiers } from '../../../services/SSOAuthService';

import '../Login.scss';
import SSOLoginForm from './SSOLoginForm';

import HomeDecorator from '../HomeDecorator';

class SSOAuthLoginView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: null,
    };

    this._handleInputChanged = this._handleInputChanged.bind(this);

    this._handleSSOSubmit = this._handleSSOSubmit.bind(this);
  }

  // componentDidMount() {
  //   const search = this.props.location.search;
  //   const qParams = querystringify.parse(search);

  //   const nx_identifier =
  //     !isNil(qParams) && has(qParams, 'nx_identifier')
  //       ? qParams.nx_identifier
  //       : null;

  //   this.setState({
  //     nx_identifier
  //   });
  // }

  render() {
    const { email } = this.state;
    const { session, isLoggingIn } = this.props;
    const isSSOAutoLogin =
      GOOGLE_SSO_ENABLED === false && BASIC_LOGIN_ENABLED === false && AUTO_LOGIN_ENABLED === true
        ? true
        : false;

    let homeComponent = (
      <div key="login" className="LoginForm">
        <SSOLoginForm
          email={email}
          singleStep={true}
          isSSOAutoLogin={isSSOAutoLogin}
          showCta={false}
          onSubmit={this._handleSSOSubmit}
          logout={this.props.logout}
          onInputChanged={this._handleInputChanged}
        />
      </div>
    );

    return HomeDecorator(homeComponent, session.error, isLoggingIn);
  }

  _handleInputChanged(type, value) {
    this.setState({
      [type]: value,
    });
  }

  _handleSSOSubmit(e) {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    this._startSSOSession();
  }

  _startSSOSession = () => {
    const { email } = this.state;

    const qParams = querystringify.parse(this.props.location.search);

    const isSSOAutoLogin =
      GOOGLE_SSO_ENABLED === false && BASIC_LOGIN_ENABLED === false && AUTO_LOGIN_ENABLED === true;

    let clientIdentifer = null;
    let nextPath = '/';
    let ssoConfigUrl = '';

    if (isSSOAutoLogin) {
      clientIdentifer =
        !isNil(qParams) && has(qParams, 'nx_identifier') ? qParams.nx_identifier : null;

      ssoConfigUrl =
        GET_USERS_IDP_URL + querystringify.stringify({ client_identifier: clientIdentifer }, true);

      nextPath =
        !isNil(qParams) && has(qParams, 'redirect_to') && startsWith(qParams.redirect_to, '/')
          ? qParams.redirect_to
          : '/';
    } else {
      ssoConfigUrl =
        isValidEmail(email) === true
          ? GET_USERS_IDP_URL + querystringify.stringify({ email: email }, true)
          : GET_USERS_IDP_URL + querystringify.stringify({ client_identifier: email }, true);
      nextPath =
        !isNil(qParams) && has(qParams, 'redirect_to') && startsWith(qParams.redirect_to, '/')
          ? qParams.redirect_to
          : '/';
    }

    fetch(ssoConfigUrl, {
      method: 'GET',
      cache: 'no-cache',
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          return response.json();
        } else {
          throw new Error(response.statusText);
        }
      })
      .then(
        (res) => {
          //TODO: Temp for assuming first valid IDP should be used
          const idp = !isEmpty(res) ? find(res, (r) => !isEmpty(r.client_config)) : null;
          if (isNil(idp)) {
            this.props.ssoAuthError(
              'This email is not configured for SSO. Please contact us for SSO configurations.',
            );
          } else {
            const data = idp.client_config;
            const isPkce =
              has(data, 'sso_type') && data.sso_type === SSO_AUTH_TYPES.oidc_pkce ? true : false;
            const tokenIdentifiers = generateTokenIdentifiers(isPkce);

            this.props.ssoIdpAuthStart({
              ssoType: data.sso_type,
              configInfo: data,
              nextPath,
              authParams: tokenIdentifiers,
            });
          }
        },
        (err) => {
          this.props.ssoAuthError();
        },
      )
      .catch((err) => {
        this.props.ssoAuthError();
      });
  };
}

export default SSOAuthLoginView;
